import { SchedulerOMSSettings } from '@lp/features/Scheduler';
import { SchedulerSettingsPageHeader } from '@lp/features/Scheduler/components';

export const OMSSchedulerSettings = () => {
  return (
    <div className="flex flex-col p-6 gap-6 min-h-full">
      <SchedulerSettingsPageHeader backLinkPath="/schedule/oms" />
      <SchedulerOMSSettings />
    </div>
  );
};
